import {
  isCognitoTokens,
  TOKEN_STORAGE_KEY,
  type CognitoTokens,
} from "@repo/auth-core";

// Tokens live in localStorage so a refresh survives a page reload. The ID
// token is what the API consumes, but we keep the refresh token to silently
// renew before expiry.
//
// Threat-model trade-off: localStorage is reachable from any script in the
// origin, so an XSS payload can exfiltrate a Cognito refresh token (default
// validity: 30 days) and replay it from anywhere until manual revocation.
// The alternative — proxying every API call through a backend that holds an
// httpOnly cookie session — closes that window but adds a new service to
// run. We accept the localStorage exposure as a deliberate choice for this
// SPA-only deployment; revisit if/when we add a session backend or expose
// long-lived tokens to broader scripts (e.g. third-party analytics).
const KEY = TOKEN_STORAGE_KEY;

export function loadTokens(): CognitoTokens | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as unknown;
    return isCognitoTokens(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function saveTokens(tokens: CognitoTokens): void {
  localStorage.setItem(KEY, JSON.stringify(tokens));
}

export function clearTokens(): void {
  localStorage.removeItem(KEY);
}
